import React from "react";
import MonacoEditor from "./MonacoEditor";
import EmptyState from "./EmptyState";
import FilePathBar from "./FilePathBar";

/**
 * Main editor area component
 * @param {Object} props - Component props
 * @param {Object} props.activeTab - Currently active tab
 * @param {string} props.fileContent - Current file content
 * @param {boolean} props.isDirty - Whether file has unsaved changes
 * @param {boolean} props.isSaving - Whether file is being saved
 * @param {boolean} props.isDarkMode - Whether dark mode is enabled
 * @param {Function} props.onContentChange - Content change handler
 * @param {Function} props.onSave - Save handler
 * @param {boolean} props.isReadOnly - Whether editor is in read-only mode
 * @returns {JSX.Element} The editor area
 */
const EditorArea = ({
  activeTab,
  fileContent,
  isDirty,
  isSaving,
  isDarkMode,
  onContentChange,
  onSave,
  isReadOnly,
}) => {
  if (!activeTab) {
    return <EmptyState />;
  }

  return (
    <div className="flex flex-col h-full">
      <FilePathBar
        filePath={activeTab.path}
        isDirty={isDirty}
        isSaving={isSaving}
        onSave={onSave}
        isReadOnly={isReadOnly}
      />
      <MonacoEditor
        fileName={activeTab.name}
        content={fileContent}
        onChange={onContentChange}
        isDarkMode={isDarkMode}
        onSave={onSave}
        isReadOnly={isReadOnly}
      />
    </div>
  );
};

export default EditorArea;
